export const shareProfileStyles = {
	root: {
		height: '32px',
		fontWeight: 700,
		px: 2,
		lineHeight: 1
	},

	urlContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		flexDirection: 'row',
		overflow: 'hidden'
	},

	urlText: {
		backgroundColor: '#1212120A',
		color: 'text.secondary',
		alignItems: 'center',
		justifyContent: 'center',
		p: 1,
		flex: 1,
		borderRadius: 1,
		borderTopRightRadius: 0,
		borderBottomRightRadius: 0,
		overflowY: 'hidden',
		overflowX: 'auto',
		boxSizing: 'content-box',
		height: '24px',
		whiteSpace: 'nowrap',
		scrollbarWidth: 'none',
		msOverflowStyle: 'none',
		'&::-webkit-scrollbar': {
			display: 'none'
		}
	},

	copyButton: {
		borderTopLeftRadius: 0,
		borderBottomLeftRadius: 0,
		backgroundColor: 'primary.main',
		fontSize: '0.875rem',

		'&.Mui-disabled': {
			backgroundColor: 'grey.500',
			color: 'text.primary'
		}
	},

	info: {
		color: 'text.secondary',
		fontSize: '0.875rem'
	}
};
